import { Link } from "react-router-dom";
import type { Scoop, ScoopStatus } from "@/types";

const statusNote: Record<ScoopStatus, string> = {
  已核实: "关键事实已通过两个以上独立来源交叉确认，内容可以放心参考。",
  核实中: "我们已收到线索并掌握部分佐证，仍在补充比对，结论可能随新证据调整。",
  多方求证: "已向当事方发出问询，目前仍在等待回应，页面会同步后续说明。",
  待补充: "现有材料尚不足以支撑完整结论，等待投稿人补充更多佐证。",
};

export default function ScoopSidebar({ scoop }: { scoop: Scoop }) {
  return (
    <aside className="space-y-5 lg:sticky lg:top-24">
      <div className="rounded-lg border border-foreground-950/10 bg-background-50 p-5">
        <h2 className="font-heading text-base font-semibold text-foreground-950">核实状态说明</h2>
        <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{statusNote[scoop.status]}</p>
        <div className="mt-4 border-t border-foreground-950/10 pt-4">
          <h3 className="text-xs font-medium uppercase tracking-wide text-foreground-500">信息来源范围</h3>
          <p className="mt-1.5 text-sm text-foreground-700">{scoop.source}</p>
        </div>
        <div className="mt-4">
          <h3 className="text-xs font-medium uppercase tracking-wide text-foreground-500">相关标签</h3>
          <div className="mt-2 flex flex-wrap gap-2">
            {scoop.tags.map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
        <div className="flex items-center gap-2 text-primary-700">
          <i className="ri-shield-keyhole-line text-xl" aria-hidden="true"></i>
          <h2 className="font-heading text-base font-semibold">你也有相关线索？</h2>
        </div>
        <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">
          如果你掌握这条爆料的更多细节或后续进展，可以通过投稿通道匿名补充。我们会与先前材料一并核实。
        </p>
        <Link
          to="/submit"
          className="mt-4 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
          补充线索
        </Link>
      </div>

      <div className="rounded-lg border border-foreground-950/10 bg-background-100 p-5">
        <h2 className="font-heading text-base font-semibold text-foreground-950">内容更正与申诉</h2>
        <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
          如果你是本条内容涉及的当事方，认为其中有事实性错误，可以联系我们。经核实后我们会在原页面显著位置发布更正说明，而不是删除处理。
        </p>
        <p className="mt-3 flex items-center gap-2 text-sm text-foreground-700">
          <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
          zhengming@kanliaobaoliao.com
        </p>
      </div>
    </aside>
  );
}